module.exports = __webpack_public_path__ + "static/media/ic_send_message.fc77118d.svg";